import {Component, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {AuthService} from '../services/auth.service';
import {Router} from '@angular/router';
import { FormControl} from '@angular/forms';
import {MemberService} from '../services/member.service';
import {AgendaService} from '../services/agenda.service';
import {EventService} from '../services/event.service';

@Component({
    selector: 'app-agenda-member',
    templateUrl: './agenda-member.component.html',
    styleUrls: ['./agenda-member.component.scss'],
    entryComponents: [
        ConfirmComponent
    ]
})
export class AgendaMemberComponent implements OnInit {

    public dataSource: MatTableDataSource<any>
    public displayedColumns: string[] = ['name'];

    //autocomplete
    public searchMemberControl: FormControl;
    public members: any[] = []
    public memberSelected: any;

    @ViewChild(MatSort, {static: true}) sort: MatSort;

    constructor (
        public _eventService: EventService,
        public _agendaService: AgendaService,
        public _memberService: MemberService
    ) {

      /*
        if (!this._authService.isOperator) {
            this.router.navigate(['home']);
        }
            */

        //   this.memberForm = this.createMemberForm();
        this.initializeAutoCompletes();
    }

    ngOnInit () {
    }

    // AUTOCOMPLETES

    initializeAutoCompletes () {

        this.searchMemberControl = new FormControl();
        this.searchMemberControl.valueChanges.subscribe(val => {
            if (val != undefined) this.updateMemberSearchList(val);
        })
    }

    cleanMemberSearch () {
        this.members = []
    }

    updateMemberSearchList (val) {

        if (val.length > 3) {

            this._memberService.selectStartAt(val)
                .subscribe((result) => {

                    this.members = []

                    result.forEach((item) => {
                        this.members.push({
                            "id": item.id,
                            "name": item.data().name,
                            "email": item.data().email,
                            "cellPhone": item.data().cellPhone
                        })

                    })

                })
        }
    }

    displayMember (value) {

        if ((value !== null) && (value !== undefined) && (value !== "")) {
            this.getAgenda(value);
            return value.name;
        } else {
            return "";
        }

    }

    getAgenda (value) {

        let appointments: any = [];

        this.memberSelected = {
            "id": value.id,
            "name": value.name,
            "email": value.email,
            "cellPhone": value.cellPhone
        }
        //    console.log("memberSelected: " + JSON.stringify(this.memberSelected))

        this._eventService.selectEventCongress()
            .subscribe((events) => {
                let eventArray: any = []
                events.forEach((item) => {
                    let entity: any = {};
                    entity = item.payload.doc.data()
                    entity.id = item.payload.doc.id
                    eventArray.push(entity)
                })

                eventArray.forEach(item => {
                   console.log("events: " + item.name)
                    this._agendaService.loadAllMemberAgendaByEvent(this.memberSelected.id, item.id)
                        .subscribe((rets) => {

                          //  console.log("event.id: " + item.id)
                          //  console.log("member.id: " + this.memberSelected.id)

                            rets.forEach((ret) => {

                                let etty: any = {}
                                etty = ret.payload.doc.data();
                                etty.id = ret.payload.doc.id

                               // console.log("etty: " + JSON.stringify(etty))
                                appointments.push(etty)
                             //   console.log("appointments: " + JSON.stringify(appointments))
                                this.dataSource = new MatTableDataSource(appointments);
                            })
                        })
                });

              //  console.log("appointmentsss final: " + JSON.stringify(appointments))
              // this.dataSource = new MatTableDataSource(appointments);
            })

    }


}

